/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useEffect} from "react";

/* css */
import "../../css/admin_layout.css";
import "../../css/admin.css";

const MainAdmin = ({setMenuType,setMenuItem}) => {
  const adminLoginState = Number(localStorage.getItem('adminLoginState'));
  console.log(adminLoginState);
  if(adminLoginState === 0) {
    window.location.href = "/LoginAdmin";
  }

  useEffect(() => {
    setMenuType('');
    setMenuItem('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* 배차현황 호출 */}
      {/* 근태/연차현황 호출 */}
    </div>
  );
}
export default MainAdmin;